/**
 * Accordion
 *
 * @module accordion
 */

const component = {

    /**
     * Init component
     * 
     * @return {boolean|undefined}
     */
	init: () => {

        component.target = document.querySelectorAll('[data-accordion]');

        if (!component.target)
            return false;

        component.target.forEach(accordion => {
            component.loadAttributes(accordion);
        });

        document.querySelectorAll('[data-accordion-heading]').forEach(item => {

            if (typeof item.dataset.accordionHover != 'undefined') {

                hoverintent(item, () => {

                    component.initEvents(item, false);

                }, () => {});

            }

            if (typeof item.dataset.accordionDebounceClick != 'undefined') {
                item.addEventListener('click', window.theme.debounce.apply(event => {
                    event.preventDefault();
                    component.initEvents(item, true);
                }, 300).bind(this));
            }else{
                item.addEventListener('click', event => {
                    event.preventDefault();
                    component.initEvents(item, true);
                });
            }            

        });
	},

     /**
     * Init Events
     * 
     * @param {item} item A data-accordion-heading object (accordion object)
     * @return {undefined}
     */

    initEvents: (item, close) => {

        component.closeAllItems(item.parentElement.parentElement, item);

        // We need to use a promisse to avoid issues with accordion
        component.toggle(item, close).then((newContentHeight) => {
            component.applyMaxHeightOnParent(item.parentElement.parentElement, item, newContentHeight);
        });

        let content = item.nextElementSibling;
        
        let tab = content.querySelector("component-tabs");

        if(tab) {

            tab.querySelectorAll("[data-tab-heading-index]").forEach(element => {

                element.addEventListener('click', event => {                    
                    content.style.maxHeight = content.scrollHeight  + "px";
                });
            });
        }
    },

    /**
     * Load accordion attributes
     * 
     * @param {object} accordion A accordion object.
     * @return {undefined}
     */
    loadAttributes: (accordion) => {

        accordion.classList.add('accordion');

        let id = Math.floor(Math.random() * 1000);

        accordion.querySelectorAll('[data-accordion-heading]').forEach((heading, index) => {

            id = id + '_' + index;

            heading.parentElement.classList.add('accordion__item');

            heading.classList.add('accordion__heading');
            heading.setAttribute('aria-expanded', 'false');
            heading.setAttribute('aria-controls', 'accordion__content' + id);
            heading.id = 'accordion__heading__' + id;

            heading.nextElementSibling.classList.add('accordion__content');
            heading.nextElementSibling.classList.add('hidden');
            heading.nextElementSibling.setAttribute('role', 'region');
            heading.nextElementSibling.setAttribute('aria-labelledby', 'accordion__heading__' + id);
            heading.nextElementSibling.id = 'accordion__content__' + id;

            if (typeof accordion.dataset.accordionDebounce != 'undefined') {
                heading.setAttribute('data-accordion-debounce-click', 'true');
            }

        });

    },

    /**
	 * Init Accordion toggle
     * 
     * @param {object} heading A accordion object.
     * @returns {Promise} Promise object represents a number.
	 */
     toggle: (heading, close) => {

        return new Promise((resolve, reject) => {

            let content = heading.nextElementSibling;

            if (heading && content) {

                let container = heading.parentElement;
                
                if (container.classList.contains('active') && close) {

                    // Close Accordion
                    container.classList.remove('active');
                    content.style.maxHeight = null;
                    heading.setAttribute('aria-expanded', 'false');
                    document.body.classList.remove("accordion-open");

                    // We need to use set time out to avoid issues with accordion animation
                    setTimeout(() => {
                        content.classList.add('hidden');
                    }, 500);

                } else {

                    // Open Accordion
                    container.classList.add('active');
                    content.classList.remove('hidden');
                    content.style.maxHeight = content.scrollHeight + "px";

                    if(heading.dataset.menuSubmenuTargetHover != null && window.screenMode != 'desktop-large'){
                        // add class in body
                        document.body.classList.add("accordion-open");
                    }

                    // Check height again for very large content
                    setTimeout(() => {
                        let new_height = content.scrollHeight + "px";
                        if(content.style.maxHeight != new_height) content.style.maxHeight = content.scrollHeight + "px";

                        if (heading.dataset.subaccordion == "true") {
                            let accordionParent = heading.parentElement.parentElement;
                            accordionParent.style.maxHeight = content.scrollHeight + accordionParent.scrollHeight + "px";
                        } 

                    }, 500);

                    heading.setAttribute('aria-expanded', 'true');

                }

                resolve(content.scrollHeight);
            }
		});
    },

    
    /**
     * Change the parent max-height (submenu)
     * @param {object} parent A data-accordion-content (accordion object)
     * @param {object} item A data-accordion-heading object (accordion object)
     * @param {integer} newContentHeight A data-accordion-content height
     * @return {undefined}
     */
    applyMaxHeightOnParent: (parent , item, newContentHeight) => {
        const hasClass = parent.querySelector('.global-menu__submenu');
        if(hasClass){
            hasClass.classList.remove('global-menu__submenu');
        }

        if (typeof parent.dataset.accordionSubmenu != 'undefined'){

            if(parent.classList.contains('accordion__content')){
                const isOpen = item.getAttribute('aria-expanded');

                if(isOpen == 'true'){
                    item.classList.add('global-menu__submenu');
                    //const childHeight = parent.querySelector('[data-accordion-content]').scrollHeight;
                    parent.style.maxHeight = parent.scrollHeight + newContentHeight + "px";
                } else{
                    item.classList.remove('global-menu__submenu');
                }
            }
        }
    },

    /**
     * Close all items
     * 
     * @param {object} accordion An accordion object.
     * @return {undefined}
     */
    closeAllItems: (accordion, item) => {

        if (typeof accordion.dataset.accordionAutoClose != 'undefined') {

            if (!item.parentElement.classList.contains('active')) {

                if (typeof accordion.dataset.accordionSubmenu != 'undefined') {
                    accordion.querySelectorAll('[data-accordion-submenu] .active [data-accordion-heading][data-menu-level2]').forEach(heading => {
                        component.toggle(heading, true);
                    });
                } else {
                    accordion.querySelectorAll('[data-accordion] .active [data-accordion-heading]').forEach(heading => {
                        component.toggle(heading, true);
                    });
                }

            }
        }
    }
};

export default component;
